import { dynamicQuestionContent, getCurrentResponseScore } from "@plura/shared/lead-forms";
import { FormJourneyItem, LeadForm } from "@plura/shared/types";
import { cn } from "@plura/shared/utils";
import { AnimatePresence, motion } from "framer-motion";
import { useFormContext } from "react-hook-form";
import RadioGroup from "../../../../molecules/RadioGroup";
import "./nps-screen.css";

interface Props {
  id: string;
  step: FormJourneyItem
  leadForm: LeadForm;
  editorMode: boolean;
  previewMode: boolean;
  active: boolean;
  handleAnswer?: () => void;
  onContentClick?: (fieldName: string, blockId: string) => void;
  hiddenFields?: {
    field: string;
    value: string;
  }[];
}

const NPSScreen = ({ id, step, editorMode, previewMode, leadForm, active, handleAnswer, onContentClick, hiddenFields }: Props) => {
  const rangeArray = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
  const form = useFormContext();
  const { conversationId, ...userResponses } = form.getValues()
  const currentResponseScore = userResponses
    ? getCurrentResponseScore(userResponses, leadForm)
    : 0

  const handleContentClick = (field: 'content' | 'secondaryContent') => {
    if ((!editorMode || (editorMode && previewMode)) || !onContentClick) return
    onContentClick(field, id)
  }

  return (
    <>
      <div className={cn('questionInner')}>
        <div>
          <h4 className={cn('question')} onClick={() => handleContentClick('content')}>
            <motion.span
              dangerouslySetInnerHTML={{
                __html: dynamicQuestionContent({
                  content: step.content,
                  score: currentResponseScore,
                  editMode: editorMode,
                  previewMode: previewMode ?? false,
                  hiddenFields,
                  journeyItems: leadForm.journeyItems ?? [],
                  userResponses
                })
              }}
            />
          </h4>
          {
            step.secondaryContent &&
            <p className={cn('caption')} onClick={() => handleContentClick('secondaryContent')}>
              <motion.span
                dangerouslySetInnerHTML={{
                  __html: dynamicQuestionContent({
                    content: step.secondaryContent,
                    score: currentResponseScore,
                    editMode: editorMode,
                    previewMode: previewMode ?? false,
                    hiddenFields,
                    journeyItems: leadForm.journeyItems ?? [],
                    userResponses
                  })
                }}
              />
            </p>
          }
        </div>
        <div>
          <motion.div className={'answerInputWrapper'}>
            <AnimatePresence initial={false}>
              <motion.div className={'fieldWrapper'}>
                <div className={'rangeWrapper'}>
                  <RadioGroup
                    id={step.blockId}
                    minLabel={<><b>0 -&nbsp;</b>Not likely at all</>}
                    maxLabel={<><b>10 -&nbsp;</b>Extremely likely</>}
                    adaptiveUI
                    disabledKeySelection={(editorMode && !previewMode) || !active}
                    options={rangeArray.map(value => ({
                      value: value.toString(),
                      label: value.toString()
                    }))}
                    item={(value, checked) => (
                      <div className={'rangeItem'}>
                        {value}
                      </div>
                    )}
                    handleOnChange={handleAnswer}
                  />
                </div>
              </motion.div>
            </AnimatePresence>
          </motion.div>
        </div>
      </div>
    </>
  );
};


export default NPSScreen